import React, { Component } from "react";
import "./style.css";

const SECTION_IDS = {
  home: "hero",
  about: "about",
  features: "features",
  workAreas: "work-areas",
  projects: "projects",
};

const menus = [
  { id: 1, title: "الرئيسية", sectionId: SECTION_IDS.home },
  { id: 2, title: "عن جذور", sectionId: SECTION_IDS.about },
  { id: 3, title: "توجهات جذور", sectionId: SECTION_IDS.features },
  { id: 4, title: "مجالات العمل", sectionId: SECTION_IDS.workAreas },
  { id: 5, title: "المشاريع", sectionId: SECTION_IDS.projects },
];

const SCROLL_OFFSET_TOP = 120;

export default class MobileMenu extends Component {
  state = {
    isMenuShow: false,
  };

  menuHandler = () => {
    this.setState((prev) => ({ isMenuShow: !prev.isMenuShow }));
  };

  scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  scrollToSection = (sectionId) => {
    if (sectionId === "hero") {
      this.scrollToTop();
      return;
    }
    const el = document.getElementById(sectionId);
    if (el) {
      const top =
        el.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET_TOP;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  handleItemClick = (sectionId) => () => {
    this.scrollToSection(sectionId);
    this.setState({ isMenuShow: false });
  };

  render() {
    const { isMenuShow } = this.state;

    return (
      <div>
        <div
          className={`mobileMenu-overlay ${isMenuShow ? "show" : ""}`}
          onClick={this.menuHandler}
          onKeyDown={(e) => e.key === "Escape" && this.menuHandler()}
          role="button"
          tabIndex={0}
          aria-label="Close menu"
        />
        <div className={`mobileMenu ${isMenuShow ? "show" : ""}`} dir="rtl">
          <div className="mobileMenu-header">
            <span className="mobileMenu-title">القائمة</span>
            <button
              type="button"
              className="mobileMenu-close"
              onClick={this.menuHandler}
              aria-label="Close"
            >
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </div>
          <ul className="responsivemenu">
            {menus.map((item) => (
              <li key={item.id}>
                <button
                  type="button"
                  className="mobile-menu-link"
                  onClick={this.handleItemClick(item.sectionId)}
                >
                  {item.title}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div
          className="showmenu"
          onClick={this.menuHandler}
          aria-label="Open menu"
        >
          <i className="fa fa-bars" aria-hidden="true" />
        </div>
      </div>
    );
  }
}
